
import { Vue } from "vue-property-decorator";
import { getCompanyName, getCareEmail } from "../../utils/syariah";

export default Vue.extend({
  name: "footerView",
  computed: {
    isSyariah(): boolean {
      return this.$store.getters.getIsSyariah();
    },
    companyName(): string {
      return getCompanyName(this.isSyariah);
    },
    careEmail(): string {
      return getCareEmail(this.isSyariah);
    }
  }
});
